<template>
  <div class="flags">
    <wa-badge
      v-for="flag in customerFlags.storedToDisplayed"
      :key="flag"
      pill
      class="flags__item"
      :class="[
        `flags__item--${flag}`,
        {
          'flags__item--mini': props.mini
        }
      ]"
    >
      <template v-if="!props.mini">
        {{ $t(`customer_flags.${flag}.label`) }}
      </template>
    </wa-badge>
  </div>
</template>

<script setup>
import '@awesome.me/webawesome/dist/components/badge/badge.js'

import { computed } from 'vue'

import { useCustomerFlags } from '@/composables/useCustomerFlags'

const props = defineProps({
  items: {
    type: Array,
    default() {
      return []
    }
  },
  mini: {
    type: Boolean,
    default: false
  }
})

const items = computed(() => {
  return (props.items || []).map((item) => item.name)
})

const customerFlags = await useCustomerFlags({
  storedList: items
})
</script>

<style scoped src="./CustomerFlags.css"></style>
